<div class="course-register-container">
  <!-- Loading State -->
  <div *ngIf="isLoading" class="loading-state">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">กำลังโหลด...</span>
    </div>
    <p class="mt-3">กำลังโหลดข้อมูลคอร์ส...</p>
  </div>

  <!-- Course Content -->
  <div *ngIf="!isLoading && courseData" class="course-content">

    <!-- Header Section -->
    <div class="course-header">
      <button class="btn-back" (click)="goBack()">
        <i class="bi bi-arrow-left"></i>
        <span>กลับ</span>
      </button>

      <div class="header-content">
        <h1 class="course-title">{{ courseData.courseTopic }}</h1>
      </div>
    </div>

    <!-- Tabs Navigation -->
    <div class="tabs-navigation">
      <button class="tab-button" [class.active]="isActiveTab('overview')" (click)="setActiveTab('overview')">
        รายละเอียด
      </button>
      <button class="tab-button" [class.active]="isActiveTab('payment')" (click)="setActiveTab('payment')">
        วิธีการชำระเงิน
      </button>
    </div>

    <!-- Tab Content -->
    <div class="tab-content-area">

      <!-- Overview Tab -->
      <div class="tab-pane" [class.active]="isActiveTab('overview')">

        <!-- Course Image Preview -->
        <div class="course-image-section" *ngIf="courseData.imageDetailUrl">
          <img [src]="courseData.imageDetailUrl" alt="{{ courseData.courseTopic }}" class="course-detail-image">
        </div>

        <!-- Course Details Grid -->
        <div class="content-section">
          <h3 class="section-title">
            <i class="bi bi-info-circle"></i>
            <span>รายละเอียดคอร์ส</span>
          </h3>
          <div class="details-grid">
            <!-- Merged from upper zone -->
            <div class="detail-card">
              <div class="detail-icon">
                <i class="bi bi-tag-fill"></i>
              </div>
              <div class="detail-content">
                <label>ค่าอบรม</label>
                <p>฿{{ formatPrice(courseData.courseFee) }}</p>
              </div>
            </div>

            <div class="detail-card">
              <div class="detail-icon">
                <i class="bi bi-clock-fill"></i>
              </div>
              <div class="detail-content">
                <label>จำนวน CPD</label>
                <p>{{ courseData.cpdHours }} ชั่วโมง</p>
              </div>
            </div>

            <div class="detail-card">
              <div class="detail-icon">
                <i class="bi bi-laptop"></i>
              </div>
              <div class="detail-content">
                <label>รูปแบบ</label>
                <p>{{ getTrainingFormatLabel(courseData.trainingFormat) }}</p>
              </div>
            </div>

            <div class="detail-card">
              <div class="detail-icon">
                <i class="bi bi-people-fill"></i>
              </div>
              <div class="detail-content">
                <label>ที่นั่ง</label>
                <p [style.color]="isSeatsFullyBooked() ? 'red' : 'inherit'">{{ getSeatAvailabilityText() }}</p>
              </div>
            </div>

            <!-- Original detail cards -->
            <div class="detail-card">
              <div class="detail-icon">
                <i class="bi bi-calendar-event"></i>
              </div>
              <div class="detail-content">
                <label>วันที่เริ่มอบรม</label>
                <p>{{ formatDate(courseData.startDate) }}</p>
              </div>
            </div>

            <div class="detail-card">
              <div class="detail-icon">
                <i class="bi bi-calendar-check"></i>
              </div>
              <div class="detail-content">
                <label>วันที่สิ้นสุด</label>
                <p>{{ formatDate(courseData.endDate) }}</p>
              </div>
            </div>

            <div class="detail-card" *ngIf="courseData.trainingLocation">
              <div class="detail-icon">
                <i class="bi bi-geo-alt"></i>
              </div>
              <div class="detail-content">
                <label>สถานที่</label>
                <p>{{ courseData.trainingLocation }}</p>
              </div>
            </div>

            <div class="detail-card">
              <div class="detail-icon">
                <i class="bi bi-award-fill"></i>
              </div>
              <div class="detail-content">
                <label>การรับรองโดย กลต.</label>
                <p>{{ getCertificationDisplayText(courseData.certificationBySEC) }}</p>
              </div>
            </div>

            <div class="detail-card" *ngIf="courseData.closeRegisterDate">
              <div class="detail-icon">
                <i class="bi bi-calendar-x"></i>
              </div>
              <div class="detail-content">
                <label>วันปิดรับการสมัคร</label>
                <p>{{ formatDate(courseData.closeRegisterDate) }}</p>
              </div>
            </div>
          </div>
        </div>

        <!-- Remarks -->
        <div class="content-section" *ngIf="courseData.remarks">
          <div class="alert-info">
            <i class="bi bi-info-circle"></i>
            <div>
              <strong>หมายเหตุ:</strong>
              <p>{{ courseData.remarks }}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Payment Tab -->
      <div class="tab-pane" [class.active]="isActiveTab('payment')">
        <div class="content-section">
          <h3 class="section-title">
            <i class="bi bi-credit-card"></i>
            <span>วิธีการชำระเงิน</span>
          </h3>
          <p class="text-muted mb-4">แสดงวิธีและช่องทางการชำระเงินที่รองรับ</p>

          <div class="payment-methods">
            <!-- Bank Transfer -->
            <div class="payment-method">
              <div class="payment-header">
                <i class="bi bi-bank"></i>
                <span>วิธีการโอนเงินผ่านธนาคาร</span>
              </div>
              <div class="payment-body">
                <p>โอนเงินผ่านธนาคาร</p>
                <div class="bank-details">
                  <p><strong>ธนาคาร:</strong> ธนาคารกรุงเทพ</p>
                  <p><strong>เลขที่บัญชี:</strong> 137-098710-7</p>
                  <p><strong>ชื่อบัญชี:</strong> โครงการฝึกอบรม สมาคมผู้ประเมินค่าทรัพย์สินแห่งประเทศไทย</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <!-- Enrollment Button (Fixed at bottom) -->
    <div class="enrollment-footer" *ngIf="courseData.courseStatusId === 2">
      <div class="footer-content">
        <div class="price-info">
          <span class="price-label">ค่าลงทะเบียน</span>
          <span class="price-amount">฿{{ formatPrice(courseData.courseFee) }}</span>
        </div>
        <button class="btn-enroll" (click)="enrollCourse()">
          <i class="bi bi-check-circle-fill"></i>
          <span>ลงทะเบียนเรียน</span>
        </button>
      </div>
    </div>

  </div>
</div>